import React from "react"
import { appConstants } from "../../../constants/app_constants"
import { Link } from "react-router-dom"
import { devUrls, urls } from "../../../config";

const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (
    <>
      <div className="footer-layout">
        <div className="container custom-container">
          <div className="footer-text-container">
            <div className="footer-text1">
              {`Copyright © ${currentYear} ${appConstants.lystlocName} Inc. All rights reserved`}
            </div>
            <div className="footer-text2">
              <a href={process.env.REACT_APP_NODE !== "prod" ? devUrls.lfTermsCnds : urls.lfTermsCnds} target="_blank">Terms & Conditions</a> | <a href={process.env.REACT_APP_NODE !== "prod" ? devUrls.lfPrivacy : urls.lfPrivacy} target="_blank">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
